import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from "react-router-dom";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import DQCompanyProgramInfoView from "../../../views/ver_24.10/ProgramRating/DQRating/DQCompanyProgramInfo.view";
import {updateCompanyInfoService, updateProgramInfoService} from "../../../services/rating.service";
import {getCompanyInfoService} from "../../../services/company.service";
import {REGIONS_MAP} from "../../../utils/META/cat_101";

const DQCompanyProgramInfoPage = () => {
    const history = useHistory();
    const { programId } = useParams();
    const [showLoader, setShowLoader] = useState(false);

    const [companyInfo, setCompanyInfo] = useState(null);

    const getCompanyInfo = async () => {
        try {
            setShowLoader(true);
            const result = await getCompanyInfoService();
            console.log("Original Region Value from API: ", result.data.comp.region);
            if (!result.error && result.data.comp) {
                if (result.data.comp) {
                        setCompanyInfo({
                            NameOrg: result.data.comp.name_org,
                            Region: result.data.comp.region,
                });
                }
            }
        } catch (e) {
            // already toasted the error
            setShowLoader(false);
        } finally {
            setShowLoader(false);
        }
    }

    useEffect(() => {
        getCompanyInfo().then((res) => `fetch initiated, ${res}`);
    }, [])

    const company_data = {
        defaultInitialValues: companyInfo ? companyInfo : {
            NameOrg: "Test Organization",
            Region: "Singapore",
            OrgTypes: "EdTech",
            Sectors: "Education",
            History: "Sample History",
            AddressOrg: "Singapore",
            WebsiteOrg: "http://example.com",
            EmailOrg: "test@email.com",
            NameContactPerson: "John Doe",
            TitleContactPerson: "Project Manager",
            EmailContactPerson: "johndoe@gmail.com",
            PhoneContactPerson: "123456789",
        },

        emptyInitialValues : {
            NameOrg: "",
            Region: "",
            OrgTypes: "",
            Sectors: "",
            History: "",
            AddressOrg: "",
            WebsiteOrg: "",
            EmailOrg: "",
            NameContactPerson: "",
            TitleContactPerson: "",
            EmailContactPerson: "",
            PhoneContactPerson: "",
        },

        company_info_exist: companyInfo && companyInfo.NameOrg && companyInfo.Region,
    };
    const program_data = {
        defaultInitialValues : {
            ProgramName: 'Sample Program',
            // ProgramAims: 'Sample aims and objectives',
            ProgramDesc:'Sample Desc',
            AgendaTopics:'AgendaDigWell',
            Status: 'Active',
            StartYear: '2023',
            UpdateYear:'2023',
            ProgramTarget: 'Workforce',
            ProgramTargetOther:'Sample Program Target',
            ProgramTargetMinAge:'20',
            ProgramTargetMaxAge:'40',
            TargetAge: 'Below5',
            TargetCountry: 'Singapore',
            ProgramVenue:'Homebased',
            ProgramDuration: 'lessthan15min',
            OtherDurationHours:'30',
            ResourcesType:'ResTypeLesson',
            ResourcesTypeOther:'Sample Resources',
            ResourcesFormat:'FormatSite',
            ResourcesFormatOther: 'Sample Resources Format',
            Links: 'http://example.com',
            Languages:'English',
            RefFramework: 'no',
            RefAlignment:'Framework Alignment',
            ProgramPrice:'CostFree',
            // Devices:'Smartphone',
            // DeviceTypeOther:'',
            // RefResource: 'Sample resources',

            //courses fields
            CourseName:'Sample course',
            CourseDesc:'Sample course description',
            CourseLearningObj:'Sample course learning objective',
            CourseTarget: 'Workforce',
            CourseTargetOther:'Sample Program Target',
            CourseTargetMinAge:'20',
            CourseTargetMaxAge:'40',
            CourseTargetAge:'Below5',
            CourseResourcesType:'ResTypeLesson',
            CourseResourcesTypeOther:'Sample Resources',
            CourseResourcesFormat:'FormatSite',
            CourseFormatOther:'Sample Course Resources Format',
        },

        emptyInitialValues : {
            ProgramName: '',
            // ProgramAims: '',
            ProgramDesc:'',
            AgendaTopics:'',
            Status: '',
            StartYear: '',
            UpdateYear:'',
            ProgramTarget: '',
            ProgramTargetOther:'',
            ProgramTargetMinAge:'',
            ProgramTargetMaxAge:'',
            TargetAge: '',
            TargetCountry: '',
            ProgramVenue:'',
            ProgramDuration: '',
            OtherDurationHours:'',
            ResourcesType:'',
            ResourcesTypeOther:'',
            ResourcesFormat:'',
            ResourcesFormatOther: '',
            Links: '',
            Languages:'',
            RefFramework: '',
            RefAlignment:'',
            ProgramPrice:'',
            // Devices:'',
            // DeviceTypeOther:'',
            // RefResource: '',

            //courses fields
            CourseName:'',
            CourseDesc:'',
            CourseLearningObj:'',
            CourseTarget: '',
            CourseTargetOther:'',
            CourseTargetMinAge:'',
            CourseTargetMaxAge:'',
            CourseTargetAge:'',
            CourseResourcesType:'',
            CourseResourcesTypeOther:'',
            CourseResourcesFormat:'',
            CourseFormatOther:'',
        },
    };
    const data = {
        company_data,
        program_data,
    }
    const company_actions = {

    };

    const program_actions = {
        submitAction : async (values) => {
            setShowLoader(true);
            try {
                const response1 = await updateCompanyInfoService(values);
                if (response1 && !response1.error) {
                    console.log("Company Info Updated");
                    const response = await updateProgramInfoService(programId, values);

                    if (response.data && response.data.program_application && response.data.program_info) {
                        console.log("Successfully updated program application: ", response.data.program_application);
                        console.log("Successfully updated program info: ", response.data.program_info);
                        history.push(`/dq_rating/${programId}`);
                    }
                }

            } catch (error) {
                console.log(error);
            } finally {
                setShowLoader(false);
            }
        },

    };

    const actions = {
        company_actions,
        program_actions,
    }
    const company_options = {

    };

    const program_options = {

    };

    const options = {
        company_options,
        program_options
    }

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <DQCompanyProgramInfoView data={data} actions={actions} options={options} />
        </>
    );
};

export default DQCompanyProgramInfoPage;